import { consumiMensili } from './consumi'
import type { Diagnostica } from './diagnostica'
import type { DatiPeriodo } from './ingresso'
import type { ModelloDichiarazione } from './modello'
import { componiQuadri } from './quadri'
import type { RegolePeriodo } from './regole-periodo'
import { validaPeriodo } from './valida-periodo'
import { liquida } from './liquidazione'

export interface EsitoDichiarazione {
  readonly modello: ModelloDichiarazione | null
  readonly diagnostiche: readonly Diagnostica[]
}

const eBloccante = (d: Diagnostica): boolean => d.gravita === 'bloccante'

/** Punto d'ingresso per worker e portale: nessun modello se c'e' anche un solo bloccante. */
export function calcolaDichiarazione(dati: DatiPeriodo, regole: RegolePeriodo): EsitoDichiarazione {
  const iniziali = validaPeriodo(dati, regole)
  if (iniziali.some(eBloccante)) return { modello: null, diagnostiche: iniziali }

  const quadri = componiQuadri(consumiMensili(dati, regole), dati, regole)
  const diagnostiche = [...iniziali, ...quadri.diagnostiche]
  if (diagnostiche.some(eBloccante)) return { modello: null, diagnostiche }

  return { modello: liquida(quadri.modello, dati, regole), diagnostiche }
}
